<template>
<section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title" />
    <div class="view__description">
        <p class="view__description__text">
        </p>
    </div>
    <div class="col-md-12 mb-5">
        <LocalFormFilter 
            :array_options="array_options"
            :form_data_filter="form_data"
            :show_view_inspections="false"
            :show_inspection="true"
            @getReport="getReport"
        />
    </div>

    <div class="tab-content" v-show="pdfSource">
        <div class="tab-pane fade active show" id="listation">
            <div class="row mb-0 no-gutters justify-content-md-center">
                <div class="col-lg-10" style="min-height: 60rem">
                    <v-card style="height: 100%">
                        <div>
                            <iframe style="width: 100%; height: 60rem;" :src="pdfSource"></iframe>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
    <WaitingModal />
</section>

<div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb" />
</div>
</template>
<script>
import axios from 'axios';
import Resources from './resources'
import FormResources from './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from '@/components/UnauthorizedComponent'
import LocalFormFilter from '@/components/QcComponent/Inspection/LocalFormFilter.vue'
import { Notyf } from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'
import moment from 'moment'
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: "CompletedInspection",

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        LocalFormFilter
    },

    data() {
        return {
            notyf,
            axios,
            is_empty: true,
            parent_id: 20,
            user: this.get_user(),
            title_page: 'Reports',
            rest_api: `search_standard_reports`,
            title: 'Completed Inspection Report',
            current_url: `/reports`,
            breadcrumb: JSON.parse(JSON.stringify(Resources.breadcrumb)),
            array_options: {
                inspection_id: [],
                room_id:    [],
                associate_id: [],
                room_type_id: [],
                inspection_template_id: [],
                building_id: [],
                level_id: [],
                area_id: [],
            },
            form_format: FormResources.form_format_2,
            form_data: FormResources.form_data_2,
            pdfSource: '',
            moment
        };
    },

    methods: {

        backToReports() {
            window.location.href = '/reports'
        },

        async fill_data(data) {
            this.array_options = data
        },

        async getInitialData() {
            const form_data = {
                module_id: this.parent_id,
                first_request: this.first_request,
                ...this.form_data
            }

            const response = await this.post('params_standard_reports', form_data)

            if (response.status) 
            {
                this.fill_data(response.data)
                
            } 
            else 
            {
                this.error_handling(response)
            }

            this.loader(false)

            return response.data
        },

        async getReport() 
        {
            if(!this.is_empty)
            {
                const { startDate, endDate } = this.form_data.date_range;

                // Check if both dates are provided
                if (!startDate || !endDate) {
                    this.notyfMesg("Both Start Date and End Date are required.", 'error')
                    return;
                }

                const start = moment(startDate);
                const end = moment(endDate);

                if (!start.isValid() || !end.isValid()) {
                    this.notyfMesg("Invalid date format.", 'error')
                    return;
                }

                const diff = end.diff(start, "days");
                if (diff < 0) {
                    this.notyfMesg("End Date cannot be before Start Date.", 'error')
                    return;
                }

                if (diff > 31) {
                    this.notyfMesg("The date range cannot exceed 31 days.", 'error')
                    return;
                }

                const form_data = {
                    standard_report_id: this.parent_id,
                    params: this.form_data
                }

                this.loader(true)

                const response = await this.post('search_standard_reports', form_data)

                if (response.status) {
                    const base64Data = await this.downloadFile(response, true)
                    var blobUrl = URL.createObjectURL(base64Data);
                    this.pdfSource = blobUrl
                } else {
                    this.error_handling(response)
                }

                this.loader(false)
            }
        },

    },

    watch: {
        form_data:{
            handler(val)
            {
                this.is_empty = true

                for (let key in val) 
                {
                    if (val[key] != "" && typeof val[key] !== "object") 
                    {
                        this.is_empty = false
                    }
                    if (typeof val[key] === "object") 
                    {
                        for (let object_key in val[key]) 
                        {
                            if (Object.prototype.hasOwnProperty.call(val[key], object_key)) 
                            {
                                if (val[key][object_key] !== "" && val[key][object_key] !== null) 
                                {
                                    this.is_empty = false
                                }
                            }
                        }
                    }
                }

                if(this.is_empty)
                {
                    this.pdfSource = ''
                }
            }, 
            deep: true
        },
    },

    async mounted() {
        if (this.hasPermissions(['Report Read'])) 
        {
            this.breadcrumb.push({
                name: this.title,
                href: '/standard-reports/qc/completed-inspection',
                arrow: '',
            }, )

            this.getInitialData()
        }
    },

}
</script>
